import React from 'react';
import { useDispatch } from 'react-redux';

const ReportStackTraceBlock = (props: any) => {
  const { isSummary, stylesForSummary, vuid, stackTraceMessage, closeDrillThru } = props;
  let dispatch = useDispatch();
  //let addedStyles = !isSummary ? { ...stylesForSummary } : {};

  const parseErrorMessage = (message: string) => {
    const parts = {
      message: '',
      cteSQL: '',
      stackTrace: ''
    };

    const cteIndex = message.indexOf('<b>CteSQL</b>:');
  const stackTraceIndex = message.indexOf('<b>StackTrace</b>:');

  if (cteIndex !== -1 && stackTraceIndex !== -1) {
    // Extract message (everything before CteSQL)
    parts.message = message.substring(0, cteIndex)
      .replace('<b>Message</b>:', '')
      .trim()
      .split('<br/>')  // Split on <br/> tags
      .join('\n');     // Join with newlines

    // Extract CteSQL (between CteSQL and StackTrace)
    parts.cteSQL = message.substring(cteIndex + '<b>CteSQL</b>:'.length, stackTraceIndex)
      .trim()
      .split('<br/>')  // Split on <br/> tags
      .join('\n');     // Join with newlines

    // Extract StackTrace (everything after StackTrace)
    parts.stackTrace = message.substring(stackTraceIndex + '<b>StackTrace</b>:'.length)
      .trim();
  }

  return parts;
};

  const errorParts = parseErrorMessage(stackTraceMessage);

  return (
    <div
      id={"React_dashboard_vu_"+ vuid}
      className="padding-small vu-drill-info"
      style={{ wordWrap: "break-word"}}
    >
      {!isSummary && (
        <div style={{margin:"10px"}}>
          <div className="close-table-drillthru" onClick={() => closeDrillThru()}>
            ← Go back to Report
          </div>
        </div>
      )}
      <div className="error-message-container">
        <div className="error-section">
          <b>Message</b>: {errorParts.message || 'Object reference not set to an instance of an object.'}
        </div>
        <div className="error-section">
          <b>CteSQL</b>: 
          <pre className="sql-block">
            {errorParts.cteSQL || 'No SQL available'}
          </pre>
        </div>
        <div className="error-section">
          <b>StackTrace</b>: 
          <pre className="stack-trace-block">
            {errorParts.stackTrace || 'Stack trace not available'}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default ReportStackTraceBlock;
